import { Button, Tooltip } from '@orbita-ui/core';
import { UltimasLiquidacionResumen } from 'core/reporte/models/UltimasLiquidacionResumen';
import { Table } from 'shared/table';
import { TablePlaceholder } from 'shared/placeholders';
import { formatDate } from 'shared/utils';
import styled from 'styled-components';

const SELECTION_ERROR_COLOR = '#dc3545';

const SelectionCheckbox = styled.input<{ $invalid?: boolean }>`
  cursor: pointer;
  ${(props) =>
    props.$invalid &&
    `
    outline: 2px solid ${SELECTION_ERROR_COLOR};
    outline-offset: 1px;
  `}
`;

export interface UltimasLiquidacionesTableProps {
  resumenes: UltimasLiquidacionResumen[];
  isLoading?: boolean;
  downloadingKeyValue?: string | null;
  selectedKeyValues: Set<string>;
  selectionInvalid?: boolean;
  onToggleSelection: (keyValue: string, selected: boolean) => void;
  onDownloadResumen?: (resumen: UltimasLiquidacionResumen) => void;
}

export const UltimasLiquidacionesTable = ({
  resumenes,
  isLoading = false,
  downloadingKeyValue = null,
  selectedKeyValues,
  selectionInvalid = false,
  onToggleSelection,
  onDownloadResumen,
}: UltimasLiquidacionesTableProps) => {
  const showPlaceholder = isLoading || !resumenes?.length;

  return (
    <Table
      thead={
        <tr>
          <th>Numero de cuenta</th>
          <th>Fecha</th>
          <th className="text-center">Descarga</th>
          <th
            className="text-center"
            style={{
              width: '48px',
              color: selectionInvalid ? SELECTION_ERROR_COLOR : undefined,
            }}
          >
            Seleccion
          </th>
        </tr>
      }
      tbody={
        <>
          {!showPlaceholder &&
            resumenes.map((row) => (
              <tr key={row.keyValue} data-testid={`resumen-${row.id}`}>
                <td className="align-middle">{row.accountNumber}</td>
                <td className="align-middle">
                  {row.closingDate ? formatDate(row.closingDate) : '-'}
                </td>
                <td className="align-middle text-center">
                  <Tooltip text="Descargar resumen" position="left">
                    <Button
                      type="button"
                      color="inverted"
                      icon="ArrowDownCircleIcon"
                      size="small"
                      loading={downloadingKeyValue === row.keyValue}
                      onClick={() => onDownloadResumen?.(row)}
                    />
                  </Tooltip>
                </td>
                <td className="align-middle text-center">
                  <SelectionCheckbox
                    type="checkbox"
                    aria-label={`Seleccionar liquidacion ${row.keyValue}`}
                    aria-invalid={selectionInvalid}
                    data-testid={`select-${row.id}`}
                    $invalid={selectionInvalid}
                    checked={selectedKeyValues.has(row.keyValue)}
                    onChange={(event) =>
                      onToggleSelection(row.keyValue, event.target.checked)
                    }
                  />
                </td>
              </tr>
            ))}
          {showPlaceholder && (
            <TablePlaceholder cols={4} rows={isLoading ? 3 : 5} />
          )}
        </>
      }
    />
  );
};
